function Publication(props) {
	const redirectToWebsite = (link) => {
		if (link !== undefined)
			window.location.href = props.link
	}
	return (
		<div className="publication" style={{ cursor: 'pointer' }} onClick={() => redirectToWebsite(props.link)}>
			<div className="h-line"></div>
			<div className="main">
				<div className="date">{props.date}</div>
				<div className="details">
					<div className="publication-publisher">
						{props.publisher}
					</div>
					<div className="publication-title">{props.title}</div>
					<div className="publication-journal">{props.journal}</div>
				</div>
				<div className="arrow">&#8599;</div>
			</div>
		</div>
	);
}

export default Publication;
